export default class ErrorMessage {
  constructor(message, data) {
    this.message = message;
    this.data = data;
  }
}
